// frontend/src/components/AppHadError.js
import React from "react";
import { Link } from "react-router-dom";

const AppHadError = () => {
  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h1>Error</h1>
      <p>We're having some issues at the moment...</p>
      <img
        src="https://media.gq.com/photos/58d2a34f4f615e6ea3a2696a/16:9/w_2560%2Cc_limit/GettyImages-631853154.jpg"
        alt="Error"
        style={{ maxWidth: "100%", height: "auto" }}
      />
      <p>Please try again later.</p>
      <p>
        If this message keeps popping up, please contact us at{" "}
        <a href="mailto:support@xsm.com">support@xsm.com</a>
      </p>
    </div>
  );
};

export default AppHadError;
